
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import {get} from 'lodash';

@connect(store => ({
  labels: get(store.labels, 'Common', {}),
}))
export default class Favicon extends Component {

  static propTypes = {
    labels: PropTypes.object.isRequired,
  }

  componentDidMount() {
    this.favicon = document.createElement('link');
    this.favicon.rel= 'icon';
    this.favicon.type = 'image/png';
    this.favicon.href = this.props.labels.favicon;
    document.head.appendChild(this.favicon);
  }

  componentDidUpdate() {
    this.favicon.href = this.props.labels.favicon;
  }

  render() {
    return null;
  }
}




// WEBPACK FOOTER //
// ./shared/react/Favicon/index.js